<template>
  <div style="display:flex;position:absolute;top:0;bottom:0;left:-40px">
    <div class="flex-y-center">
      <div class="col-line"></div>
      <slot />
      <div class="col-line"></div>
    </div>
  </div>
</template>

<script setup>
import { reactive, defineProps } from 'vue'

defineProps({
  type: String
})

const state = reactive({
  color: '#f00'
})
console.log(state)
</script>

<style scoped>
.flex-y-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.col-line {
  width: 1px;
  height: 50%;
  background-color: #eee;
}
</style>
